// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/soc-frontend/" + chunkId + "." + {"4":"b417a32f","81":"5bca8ee9","223":"fc717c20","325":"51892723","495":"9538213d","682":"e68029ab","967":"7f202628"}[chunkId] + ".chunk.js";
};